export default "__VITE_ASSET__f_6y1duc__"